export default __webpack_public_path__ + "static/media/coinbase.f8c4c764.svg";